const MOBILE_USER_AGENT = /iPhone|iPad|iPod|Android/i;

/**
 * Whether the current device is a mobile phone/tablet, based on the user agent.
 */
export const useIsMobileDevice = () => {
    const isMobileDevice = () => {
        if (import.meta.server) {
            return false;
        }

        return MOBILE_USER_AGENT.test(navigator.userAgent);
    };

    return { isMobileDevice };
};
